import { Reveal } from "@/components/site/Reveal";
import { BUSINESS } from "@/data/site";

// "Trusted by" logo wall — social proof from recognisable organisations.
export const TrustedBy = () => (
  <section className="py-20 lg:py-28 border-t border-hairline bg-void" data-testid="trusted-by">
    <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
      <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        <div className="lg:col-span-5">
          <Reveal>
            <p className="font-mono text-xs tracking-[0.25em] text-brand mb-6 flex items-center gap-3">
              <span className="inline-block w-8 h-px bg-brand" />
              TRUSTED BY
            </p>
            <h2 className="font-heading uppercase leading-[0.95] tracking-tight text-3xl sm:text-4xl lg:text-5xl text-stark">
              Trusted by big<br />names in Yorkshire.
            </h2>
            <p className="mt-6 text-concrete leading-relaxed max-w-md">
              From the <span className="text-brand font-semibold">NHS</span> and{" "}
              <span className="text-brand font-semibold">Strike Padel</span> to countless homes and
              businesses, {BUSINESS.name} is trusted to deliver electrical work that's done properly — first time.
            </p>
          </Reveal>
        </div>

        <div className="lg:col-span-7">
          <Reveal delay={0.1}>
            <ul className="grid grid-cols-2 sm:grid-cols-3 gap-4" data-testid="trusted-logos">
              {/* Public sector */}
              <li className="group flex items-center justify-center h-24 rounded-2xl bg-surface ring-1 ring-hairline transition-all duration-300 hover:ring-brand/40 hover:shadow-[0_16px_40px_-20px_rgba(30,86,214,0.4)]">
                <span className="font-heading uppercase tracking-tight text-base text-stark text-center leading-tight px-3">
                  Public<br /><span className="text-concrete text-sm">Sector</span>
                </span>
              </li>

              {/* Sports & leisure */}
              <li className="group flex items-center justify-center h-24 rounded-2xl bg-surface ring-1 ring-hairline transition-all duration-300 hover:ring-brand/40 hover:shadow-[0_16px_40px_-20px_rgba(30,86,214,0.4)]">
                <span className="font-heading uppercase tracking-tight text-base text-stark text-center leading-tight px-3">
                  Sports<br /><span className="text-concrete text-sm">& Leisure</span>
                </span>
              </li>

              {/* Padel Centres cluster */}
              <li className="group flex items-center justify-center h-24 rounded-2xl bg-surface ring-1 ring-hairline transition-all duration-300 hover:ring-brand/40 hover:shadow-[0_16px_40px_-20px_rgba(30,86,214,0.4)]">
                <span className="font-heading uppercase tracking-tight text-lg text-stark text-center leading-tight px-3">
                  Padel<br /><span className="text-concrete text-sm">Centres</span>
                </span>
              </li>

              {/* Retail & hospitality */}
              <li className="group flex items-center justify-center h-24 rounded-2xl bg-surface ring-1 ring-hairline transition-all duration-300 hover:ring-brand/40 hover:shadow-[0_16px_40px_-20px_rgba(30,86,214,0.4)]">
                <span className="font-heading uppercase tracking-tight text-base text-stark text-center leading-tight px-3">
                  Restaurants<br /><span className="text-concrete text-sm">& Takeaways</span>
                </span>
              </li>

              {/* Offices */}
              <li className="group flex items-center justify-center h-24 rounded-2xl bg-surface ring-1 ring-hairline transition-all duration-300 hover:ring-brand/40 hover:shadow-[0_16px_40px_-20px_rgba(30,86,214,0.4)]">
                <span className="font-heading uppercase tracking-tight text-base text-stark text-center leading-tight px-3">
                  Offices<br /><span className="text-concrete text-sm">& Workspaces</span>
                </span>
              </li>

              {/* And many more */}
              <li className="flex items-center justify-center h-24 rounded-2xl glossy-card">
                <span className="font-heading uppercase tracking-tight text-base text-white text-center leading-tight px-3">
                  & many<br />more
                </span>
              </li>
            </ul>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
